export default {
  'component.globalHeader.search': 'Ҷустуҷӯ',
  'component.globalHeader.help': 'Ёрӣ',
  'component.globalHeader.notification': 'Огоҳинома',
};


